import React from 'react';
import {  Button } from 'antd';
import type { AgentSwitchNotification as AgentSwitchNotificationType } from '../../../../types';
import './AgentSwitchNotification.scss';

interface AgentSwitchNotificationProps {
  notification: AgentSwitchNotificationType | null;
  onSwitch: () => void;
  onSkip: () => void;
}

const AgentSwitchNotification: React.FC<AgentSwitchNotificationProps> = ({
  notification,
  onSwitch,
  onSkip,
}) => {
  if (!notification) {
    return null;
  }

  return (
    <div className="agent-switch-notification">
      <div className="notification-content">
        <p className="notification-message">{notification.message}</p>
        <div className="notification-actions">
          <Button
            type="primary"
            onClick={onSwitch}
            className="switch-button"
          >
            Chuyển đổi trợ lý
          </Button>
          <Button onClick={onSkip} className="skip-button">
            Bỏ qua
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AgentSwitchNotification;

